import { WarningOutlined } from '@core/ui';
import { useAppSelector } from '@online-webinar/store';
import { DateTime } from 'luxon';
import { Trans, getI18n } from 'react-i18next';

export const EventEndedInfo = () => {
    const endOn = useAppSelector((state) => state.liveWebinar.endOn);
    const endedOn = useAppSelector((state) => state.liveWebinar.endedOn);

    const endTime = endedOn ?? endOn;
    if (!endTime) {
        return <></>;
    }

    const datetime = DateTime.fromISO(endTime).toLocal().setLocale(getI18n().language);
    const date = datetime.toLocaleString();
    const time = datetime.toLocaleString(DateTime.TIME_SIMPLE);
    return (
        <div className="absolute inset-0 bg-linear-to-b from-primary/95 to-primary/75 flex items-center justify-center z-10">
            <div className="relative max-w-9/10 bg-white rounded-md mx-auto px-5 py-3">
                <WarningOutlined classNames="w-10 h-10 fill-warning mb-2" />
                <p className="font-medium">
                    <Trans components={{ span: <span className="font-normal" /> }} values={{ date: date, time: time }} i18nKey="Broadcaster.Message.Ended" />
                </p>
            </div>
        </div>
    );
};
